module.exports = __webpack_public_path__ + "a6aadea5f9782f32daedaeb57366b106.svg";